import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { EpaApi } from '../../../../services'
import { WaterSystemsMetricsInitialState } from '../waterSystemMetrics.slice'
import { IWaterSystemsMetrics, RequestConfig } from '../../../../types';

export const fetchWaterSystemMetricsAsync = createAsyncThunk(
  'metrics/fetchMetrics',
  async ({ options }: { options?: RequestConfig },
    { rejectWithValue },) => {
    try {

      const response = await EpaApi.fetchWaterSystemsMetrics(options);
      return (response as AxiosResponse<any>).data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const fetchWaterSystemMetricsAsyncBuilder = (
  builder: ActionReducerMapBuilder<WaterSystemsMetricsInitialState>
) => {
  builder.addCase(fetchWaterSystemMetricsAsync.pending, (state) => {
    state.pendingRequests = (state.pendingRequests || 0) + 1;
    state.loading = true;
    state.success = false;
    state.error = '';
  });

  builder.addCase(
    fetchWaterSystemMetricsAsync.fulfilled,
    (state, action: PayloadAction<IWaterSystemsMetrics>) => {
      state.pendingRequests = Math.max(0, (state.pendingRequests || 1) - 1);
      state.loading = state.pendingRequests > 0;
      state.success = true;
      state.data = action.payload;
    }
  );

  builder.addCase(
    fetchWaterSystemMetricsAsync.rejected,
    (state, action: PayloadAction<any>) => {
      state.pendingRequests = Math.max(0, (state.pendingRequests || 1) - 1);
      state.loading = state.pendingRequests > 0;
      state.success = false;
      state.error = action.payload;
    }
  );
};